import { api } from '../../../../services/api'

export async function salvarCotacao(data) {
  const response = await api.post('/site/v2/cotacao-frete/armazena-frete-transportadoras', data)

  return response.data
}
